define('lib/transforms/inventory.detail',[], function () {

  return function __convertToUIResultObjectForDetail(card) {
    var model = {
      summary: {
        extColor: {
          name: card.color.exterior.name,
          image: '',
          hex: [card.color.exterior.hex]
        },
        engine: card.engine,
        transmission: card.transmission,
        packages: null,
        msrp: card.formatted_msrp
      },
      packages: card.packages,
      card: card
    };
    // DataLayer, drop properties that we do NOT want on our detail view
    delete card.dataLayer.list_item_index;
    delete card.dataLayer.link_text;
    // add images to be used in inv detail slideshow to the following array
    // model.summary.images = [card.image];
    model.summary.images = [];
    model.summary.intColor = {
      name: card.color.interior.name,
      image: card.color.interior.img,
      hex: ''
    };

    /* If our card has an exteriorvirtual property, use that instead */
    if (card.color.hasOwnProperty('exteriorvirtual')) {
      model.summary.extColor = {
        name: card.color.exteriorvirtual.name,
        hex: [card.color.exteriorvirtual.hex[0], card.color.exteriorvirtual.hex[1]],
        isVirtual: true
      };
    }

    /* If our card has an interiorvirtual property, use those images instead */
    if (card.color.hasOwnProperty('interiorvirtual')) {
      model.summary.intColor = {
        name: card.color.interiorvirtual.name,
        image: card.color.interiorvirtual.img,
        hex: ''
      };
    }
    return model;
  };
});

